import { useNavigate } from "react-router-dom";
import arrowLeft from "../assets/images/navbar/arrow-left.png";

// Aligned with mobile App/Data/StaticContent.ts ABOUT_US
const ABOUT_US = [
  {
    paragraphs: [
      "Dudos is your all-in-one food companion — discover restaurants, order your favourite meals, dine in, and enjoy exclusive offers, all from one app.",
    ],
  },
  {
    title: "Our Mission",
    paragraphs: [
      "We aim to make great food experiences effortless by connecting food lovers with the best local restaurants and dining options.",
    ],
  },
  {
    title: "What We Offer",
    paragraphs: [
      "From quick deliveries and group orders to dine-in bookings and curated cuisines, Dudos is built to serve every kind of food moment.",
      "With Duddus+, members enjoy free deliveries, priority support, and exclusive deals from partner brands.",
    ],
  },
  {
    title: "Contact Us",
    paragraphs: [
      "Have feedback or need help? Reach us anytime through Help and Support in the app. We would love to hear from you.",
    ],
  },
];

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 mt-[7.5rem] md:mt-[72px]">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 flex items-center justify-center"
          >
            <img src={arrowLeft} alt="back" className="w-6 h-6 dark:invert" />
          </button>
          <h1 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold">
            About Us
          </h1>
        </div>

        <div className="rounded-[16px] border dark:border-gray-700 bg-white dark:bg-gray-800 p-6 space-y-6">
          {ABOUT_US.map((section, idx) => (
            <div key={idx}>
              {section.title && (
                <h2 className="text-[#050505] dark:text-white font-urbanist text-[18px] font-semibold mb-2">
                  {section.title}
                </h2>
              )}
              {section.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className="text-[#6A6A6A] dark:text-gray-400 font-urbanist text-[15px] leading-[160%] mb-2"
                >
                  {p}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
